import { render } from "./homeNewsCentre.vue?vue&type=template&id=45017c18&scoped=true"
import script from "./homeNewsCentre.vue?vue&type=script&lang=js"
export * from "./homeNewsCentre.vue?vue&type=script&lang=js"

import "./homeNewsCentre.vue?vue&type=style&index=0&id=45017c18&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45017c18"]])

export default __exports__